import { z } from "zod";
import { DayOfWeekSchema } from "../../types/supabase.types.gen";
import { zodDateSchema } from "../shared";
import { contractMutationBodySchema, postContractResponseSchema } from "./mutation";

/**
 * POST /contracts/extension-amendments body: extension amendment contract row.
 * When `parent_remuneration_profile_id` points at a structured profile, the API clones it
 * and dual-writes legacy remu columns, except `overtime`, which stays the free text from the body.
 * A `legacy_import` parent is not cloned: scalar remu columns from the body are kept.
 */
export const postExtensionAmendmentBodySchema = contractMutationBodySchema
  .omit({ remuneration_profile_id: true, amendment_type: true, remuneration_profile: true })
  .extend({
    amendment_type: z.literal("extension"),
    contract_key: z.number().int().positive(),
    talent_id: z.guid(),
    owner_id: z.guid(),
    mission_id: z.guid(),
    agency_id: z.guid(),
    workspace_id: z.guid(),
    start_date: zodDateSchema,
    end_date: zodDateSchema,
    working_days: z.array(DayOfWeekSchema).min(1),
    hourly_wage: z.number(),
    coefficient: z.number(),
    address_id: z.guid(),
    is_sirh_request: z.boolean(),
    job_name: z.string().min(1),
    is_termination_bonus_paid_monthly: z.boolean(),
    parent_remuneration_profile_id: z.guid().optional(),
  });

export const postExtensionAmendmentResponseSchema = postContractResponseSchema;

export type PostExtensionAmendmentBody = z.infer<typeof postExtensionAmendmentBodySchema>;
export type PostExtensionAmendmentResponse = z.infer<typeof postExtensionAmendmentResponseSchema>;
